// REQ-1 · Servicio de Seguimiento de Siniestros y Reclamos.
// Consume el endpoint público de consulta por ID.

import request from '..';
import { ClaimStatusResponse } from '../../Interfaces/ClaimStatus.interface';

// Base del endpoint: mismo prefijo público que el resto de servicios (ya enrutado por el gateway).
const SERVER = `${process.env.REACT_APP_SERVER_ENVIRONMENT}/api/v1/pss-bff-public`;

/**
 * Obtiene el estado de seguimiento de un siniestro/reclamo por su ID (shortId).
 * Reusa el path ya enrutado por el gateway y discrimina con ?view=status
 * (evita depender de que devops agregue el sub-path /status/):
 *   GET {SERVER}/tracking/:id?view=status
 */
export const getClaimStatusById = async (id: string): Promise<{ data: ClaimStatusResponse }> =>
  await request({
    url: `${SERVER}/tracking/${encodeURIComponent(id)}?view=status`,
    method: 'GET',
  });
